var _path, _rect;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUserSidebar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7 6C7 8.75667 9.24333 11 12 11C14.7567 11 17 8.75667 17 6C17 3.24333 14.7567 1 12 1C9.24333 1 7 3.24333 7 6ZM20.8889 22.1111H22V21C22 16.7122 18.51 13.2222 14.2222 13.2222H9.77778C5.48889 13.2222 2 16.7122 2 21V22.1111H20.8889ZM12 14.3333C12.4602 14.3333 12.8333 14.7064 12.8333 15.1666V16.8333H14.5C14.9602 16.8333 15.3333 17.2064 15.3333 17.6666C15.3333 18.1269 14.9602 18.4999 14.5 18.4999H12.8333V20.1666C12.8333 20.6269 12.4602 20.9999 12 20.9999C11.5397 20.9999 11.1666 20.6269 11.1666 20.1666V18.4999H9.49998C9.03974 18.4999 8.66665 18.1268 8.66665 17.6666C8.66665 17.2064 9.03974 16.8333 9.49998 16.8333H11.1666V15.1666C11.1666 14.7064 11.5397 14.3333 12 14.3333Z",
    fill: "#98A2B3"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 8,
    y: 14,
    width: 8,
    height: 7,
    fill: "#98A2B3"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUserSidebar);
export default __webpack_public_path__ + "static/media/user_sidebar.ba48ece6f947864c1b155342f30f4a9a.svg";
export { ForwardRef as ReactComponent };